
import { Row, Card, Col, Form, Button } from "react-bootstrap";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import Stack from 'react-bootstrap/Stack';

var attr = [
    /*accept: string | undefined;
    checked: boolean | undefined;
    disabled: boolean | undefined;
    height: number | string | undefined;
    list: string | undefined;
    max: number | string | undefined;
    maxLength: number | undefined;
    min: number | string | undefined;
    minLength: number | undefined;
    multiple: boolean | undefined;
    name: string | undefined;
    pattern: string | undefined;
    placeholder: string | undefined;
    readOnly: boolean | undefined;
    required: boolean | undefined;
    size: number | undefined;
    src: string | undefined;
    step: number | string | undefined;
    value: string | ReadonlyArray<string> | number | undefined;
    width: number | string | undefined;*/

    "readOnly"
]

export const FormTextInput =  ({ ...props/*fieldName, hideLabel, displayLabelFunc, data, fieldData, displayErrorsFunc*/ }) => {
    //console.log(props.horizontalForm);
    //console.log(props);
    
    var f = {
        orgType: props.orgType,
        fieldName: props.fieldName,
        hideLabel: props.hideLabel,
        //labelColumns: props.labelColumns,
        horizontalForm: "horizontalForm" in props ? {
            is: props.horizontalForm.is,
            labelCols: 'labelCols' in props.horizontalForm ? props.horizontalForm.labelCols : {},
            inputCols: 'inputCols' in props.horizontalForm ? props.horizontalForm.inputCols : {}
        }:{},

        height: props.height,//number | string | undefined;
        list: props.list,//string | undefined;
        max: props.max,//number | string | undefined;
        maxLength: props.maxLength,//number | undefined;
        min: props.min,//number | string | undefined;
        minLength: props.minLength,//number | undefined;
        multiple: props.multiple,//boolean | undefined;
        pattern: props.pattern,//string | undefined;
        required: props.required,//boolean | undefined;
        size: props.size,//number | undefined;
        step: props.step,//number | string | undefined;
        width: props.width,//number | string | undefined;
        form: props.form,
        spellcheck: props.spellcheck,
        autoComplete: props.autoComplete,
        autoFocus: props.autoFocus,
        
        data: {
            data: props.data,
            fieldData: props.fieldData
        },
        functions: {
            displayLabelFunc: props.displayLabelFunc,
            displayErrorsFunc: props.displayErrorsFunc
        }
    }



    var d = f.data.data[f.fieldName];
    var fieldD = f.data.fieldData[f.fieldName];

    var showInputField = function(orgTypesArr, orgType){
        //console.log(orgTypesArr);
        var display = true;
        orgTypesArr.forEach(type => {
            //console.log(type.toLowerCase() + " " +  orgType.toLowerCase());
            if(type.toLowerCase() == orgType.toLowerCase()){
                //console.log("Equals");
                display=false;
            }
        });
        return display;
    }

    var getVarValue = function(value){
        if(typeof value === 'function'){
            return value();
        }
        else{
            return value;
        }
    };

    var getColSize = function(colType, size) {
        var horiz = f.horizontalForm;
        var colTypeVars = horiz[colType];

        if(colType in horiz){
            if(size in colTypeVars){
                return colTypeVars[size]; 
            }
            else{
                return null;
            }
        }
        else{
            return null;
        }
    }

    var getColLabelSizes = function(size) {
        var horiz = f.horizontalForm;

        if('labelCols' in horiz){
            var colTypeVars = horiz['labelCols'];
            if(size in colTypeVars){
                return colTypeVars[size]; 
            }
            else{
                return null;
            }
        }
        else{
            return null;
        }
    }


    var getFormFieldAlignment = function(){
        var horiz = f.horizontalForm;
        
        if('is' in horiz){
            
            if(horiz.is==true){
                //console.log("horiz.is==true");
                return Row;
            }
            else{
                return Col;
            }
        }
        else{
            return Col;
        }
    }

    //console.log(fieldD);
    if(showInputField(fieldD.hideFieldOrgTypes, f.orgType)){
        //console.log(f.horizontalForm);
        switch (fieldD.type) {
            
            /*case 'test':
                //console.log("test");
                //console.log(d);
                return (
                    <Form.Group as={getFormFieldAlignment()} className="mb-3" controlId={props.data.name}>
                        {f.functions.displayLabelFunc(f.fieldName, f.hideLabel, getColLabelSizes, getFormFieldAlignment())}
                        <Col
                            xs={getColSize("inputCols",'xs')} 
                            sm={getColSize("inputCols",'sm')} 
                            md={getColSize("inputCols",'md')} 
                            lg={getColSize("inputCols",'lg')} 
                            xl={getColSize("inputCols",'xl')} 
                            xxl={getColSize("inputCols",'xxl')} 
                        >
                            <Form.Control
                                type={props.data.type}
                                name={props.data.name}
                                value={props.data.value}
                                placeholder={props.data.display.placeholder}
                                title={props.data.display.title}
                                onChange={props.data.onChange}
                                isInvalid={props.data.validation.isInvalid ? "invalid":""}
                                readOnly={getVarValue(props.data.readOnly) ? 'readOnly' : ''}
                                disabled={props.data.disabled ? 'disabled' : ''}

                                autoComplete={f.autoComplete}
                                list={f.list}
                                maxLength={f.maxLength}
                                minLength={f.minLength}
                                pattern={f.pattern}
                                size={f.size}
                                spellcheck={f.spellcheck}
                                ref={props.data.InputRef}
                            />
                            <Form.Text className="text-muted">
                                {getVarValue(props.data.display.description)}
                            </Form.Text>
                            <Form.Control.Feedback type="invalid">
                                {f.functions.displayErrorsFunc(f.fieldName)}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                );*/
            case 'text':
                //console.log("text");
                //console.log(d);
                return (
                    <Form.Group as={getFormFieldAlignment()} className="mb-3" controlId={fieldD.name}>
                        {f.functions.displayLabelFunc(f.fieldName, f.hideLabel, getColLabelSizes, getFormFieldAlignment())}
                        <Col
                            xs={getColSize("inputCols",'xs')} 
                            sm={getColSize("inputCols",'sm')} 
                            md={getColSize("inputCols",'md')} 
                            lg={getColSize("inputCols",'lg')} 
                            xl={getColSize("inputCols",'xl')} 
                            xxl={getColSize("inputCols",'xxl')} 
                        >
                            <Form.Control
                                type={fieldD.type}
                                name={fieldD.name}
                                value={d.value}
                                placeholder={fieldD.display.placeholder}
                                //title={fieldD.display.title}
                                onChange={d.onChange}
                                isInvalid={d.validation.isInvalid ? "invalid":""}
                                readOnly={getVarValue(d.readOnly) ? 'readOnly' : ''}
                                disabled={getVarValue(d.disabled) ? 'disabled' : ''}

                                autoComplete={f.autoComplete}
                                list={f.list}
                                maxLength={f.maxLength}
                                minLength={f.minLength}
                                pattern={f.pattern}
                                size={f.size}
                                spellcheck={f.spellcheck}
                                ref={fieldD.InputRef}
                            />
                            <Form.Text className="text-muted">
                                {getVarValue(fieldD.display.description)}
                            </Form.Text>
                            <Form.Control.Feedback type="invalid">
                                {f.functions.displayErrorsFunc(f.fieldName)}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                );
                case 'date':
                    return (
                        <Form.Group as={getFormFieldAlignment()} className="mb-3" controlId={fieldD.name}>
                            {f.functions.displayLabelFunc(f.fieldName, f.hideLabel, getColLabelSizes, getFormFieldAlignment())}
                            <Col 
                                xs={getColSize("inputCols",'xs')} 
                                sm={getColSize("inputCols",'sm')} 
                                md={getColSize("inputCols",'md')} 
                                lg={getColSize("inputCols",'lg')} 
                                xl={getColSize("inputCols",'xl')} 
                                xxl={getColSize("inputCols",'xxl')} 
                             >
                                <Form.Control
                                    type={fieldD.type}
                                    name={fieldD.name}
                                    value={d.value}
                                    placeholder={fieldD.display.placeholder}
                                    //title={fieldD.display.title}
                                    onChange={d.onChange}
                                    isInvalid={d.validation.isInvalid ? "invalid":""}
                                    readOnly={getVarValue(d.readOnly) ? 'readOnly' : ''}
                                    disabled={getVarValue(d.disabled) ? 'disabled' : ''}
                                    
                                    max={f.max}
                                    min={f.min}
                                    step={f.step}

                                    ref={fieldD.InputRef}
                                />
                                <Form.Text className="text-muted">
                                    {getVarValue(fieldD.display.description)}
                                </Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    {f.functions.displayErrorsFunc(f.fieldName)}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                    );
            case 'select':
                return (
                    <Form.Group as={getFormFieldAlignment()} className="mb-3" controlId={fieldD.name}>
                        {f.functions.displayLabelFunc(f.fieldName, f.hideLabel, getColLabelSizes, getFormFieldAlignment())}
                        <Col 
                            xs={getColSize("inputCols",'xs')} 
                            sm={getColSize("inputCols",'sm')} 
                            md={getColSize("inputCols",'md')} 
                            lg={getColSize("inputCols",'lg')} 
                            xl={getColSize("inputCols",'xl')} 
                            xxl={getColSize("inputCols",'xxl')} 
                        >
                            <Form.Select
                                name={fieldD.name}
                                onChange={d.onChange}
                                isInvalid={d.validation.isInvalid? "invalid":""}
                                readOnly={getVarValue(d.readOnly) ? 'readOnly' : ''}
                                disabled={getVarValue(d.disabled) ? 'disabled' : ''}

                                autoComplete={f.autoComplete}
                                autoFocus={f.autoFocus}
                                form={f.form}
                                multiple={f.multiple}
                                size={f.size}

                                ref={fieldD.InputRef}
                            >
                                {
                                    d.options.map((v) => 
                                        <option key={fieldD.name+ "_" + v.index} value={v.value} /*title={v.title}*/ selected={v.isSelected}>{v.displayValue}</option>
                                    )
                                    
                                }
                            </Form.Select>
                            <Form.Text className="text-muted">
                                {getVarValue(fieldD.display.description)}
                            </Form.Text>
                            <Form.Control.Feedback type="invalid">
                                {f.functions.displayErrorsFunc(f.fieldName)}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    
                );

            case 'radio':
                return (
                    <fieldset>
                        <Form.Group as={getFormFieldAlignment()} className="mb-3" controlId={fieldD.name}>
                        
                            {f.functions.displayLabelFunc(f.fieldName, f.hideLabel, getColLabelSizes, getFormFieldAlignment(),true)}
                            <Col 
                                xs={getColSize("inputCols",'xs')} 
                                sm={getColSize("inputCols",'sm')} 
                                md={getColSize("inputCols",'md')} 
                                lg={getColSize("inputCols",'lg')} 
                                xl={getColSize("inputCols",'xl')} 
                                xxl={getColSize("inputCols",'xxl')} 
                            >   
                                
                                {
                                    d.radioButtons.map((v) => 
                                        <Form.Check
                                            key={fieldD.name+ "_" + v.id}
                                            type="radio"
                                            id={v.id}
                                            inline={v.inline}
                                            //title={v.title}
                                            label={v.label}
                                            name={v.name}
                                            value={v.value}
                                            onChange={v.onChange}
                                            checked={v.isChecked}
                                            isInvalid={d.validation.isInvalid? "invalid":""}
                                            //aria-label="test"

                                            ref={fieldD.InputRef}
                                        />
                                    )
                                }
                                
                                <Form.Text className="text-muted">
                                    {fieldD.display.description}
                                </Form.Text>
                                <Form.Control.Feedback className={d.validation.isInvalid? "is-invalid":""} type="invalid">
                                    {f.functions.displayErrorsFunc(f.fieldName)}
                                </Form.Control.Feedback>
                            </Col>
                        
                        </Form.Group>
                    </fieldset>
                );

            case 'checkbox':
                return (
                    <fieldset>
                        <Form.Group as={getFormFieldAlignment()} className="mb-3" controlId={fieldD.name}>
                            {f.functions.displayLabelFunc(f.fieldName, f.hideLabel, getColLabelSizes, getFormFieldAlignment(),true)}
                            <Col 
                                xs={getColSize("inputCols",'xs')} 
                                sm={getColSize("inputCols",'sm')} 
                                md={getColSize("inputCols",'md')} 
                                lg={getColSize("inputCols",'lg')} 
                                xl={getColSize("inputCols",'xl')} 
                                xxl={getColSize("inputCols",'xxl')} 
                            >
                                {
                                    d.checkBoxes.map((v) => 
                                        <Form.Check
                                            key={fieldD.name+ "_" + v.id}
                                            type="checkbox"
                                            id={v.id}
                                            //title={v.title}
                                            label={v.label}
                                            name={v.name}
                                            value={v.value}
                                            onChange={v.onChange}
                                            checked={v.isChecked}
                                            isInvalid={d.validation.isInvalid ? "invalid":""}
                                            disabled={getVarValue(v.disabled) ? true : false}

                                            ref={fieldD.InputRef}
                                        />
                                    )
                                }
                                <Form.Text className="text-muted">
                                    {fieldD.display.description}
                                </Form.Text>
                                <Form.Control.Feedback className={d.validation.isInvalid ? "is-invalid":""} type="invalid">
                                    {f.functions.displayErrorsFunc(f.fieldName)}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                    </fieldset>
                );
            case 'password': 
                return (
                    <Form.Group as={getFormFieldAlignment()} className="mb-3" controlId={fieldD.name}>
                        {f.functions.displayLabelFunc(f.fieldName, f.hideLabel, getColLabelSizes, getFormFieldAlignment())}
                        <Col
                            xs={getColSize("inputCols",'xs')} 
                            sm={getColSize("inputCols",'sm')} 
                            md={getColSize("inputCols",'md')} 
                            lg={getColSize("inputCols",'lg')} 
                            xl={getColSize("inputCols",'xl')} 
                            xxl={getColSize("inputCols",'xxl')} 
                        >
                            <Form.Control
                                type={fieldD.type}
                                name={fieldD.name}
                                value={d.value}
                                placeholder={fieldD.display.placeholder}
                               // title={fieldD.display.title}
                                onChange={d.onChange}
                                isInvalid={d.validation.isInvalid ? "invalid":""}
                                readOnly={getVarValue(d.readOnly) ? 'readOnly' : ''}
                                disabled={getVarValue(d.disabled) ? 'disabled' : ''}

                                autoComplete={f.autoComplete}
                                list={f.list}
                                maxLength={f.maxLength}
                                minLength={f.minLength}
                                pattern={f.pattern}
                                size={f.size}
                                spellcheck={f.spellcheck}
                                ref={fieldD.InputRef}
                            />
                            <Form.Text className="text-muted">
                                {getVarValue(fieldD.display.description)}
                            </Form.Text>
                            <Form.Control.Feedback type="invalid">
                                {f.functions.displayErrorsFunc(f.fieldName)}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                );
            case 'tel': 
            //console.log(d);
                return (
                    <Form.Group as={getFormFieldAlignment()} className="mb-3" controlId={fieldD.name}>
                        {f.functions.displayLabelFunc(f.fieldName, f.hideLabel, getColLabelSizes, getFormFieldAlignment())}
                        <Col
                            xs={getColSize("inputCols",'xs')} 
                            sm={getColSize("inputCols",'sm')} 
                            md={getColSize("inputCols",'md')} 
                            lg={getColSize("inputCols",'lg')} 
                            xl={getColSize("inputCols",'xl')} 
                            xxl={getColSize("inputCols",'xxl')} 
                        >
                            
                                
                             <PhoneInput
                                defaultMask="(...) ...-...."
                                alwaysDefaultMask="true"
                                country={"us"}
                                autoFormat="true"
                                enableAreaCodes="true"
                                disableCountryCode="true"
                                disableDropdown="true"
                                disableSearchIcon="true"
                                disableCountryGuess="true"
                                buttonStyle={{display: 'none'}}
                                value={d.value}
                                onChange={(value, data, event, formattedValue) => d.onChange(value, data, event, formattedValue)}
                                placeholder={fieldD.display.placeholder}
                                title="title"
                                inputProps={{
                                    type:"tel",
                                    id:fieldD.name,
                                    name:fieldD.name,
                                    title:fieldD.display.title,
                                    //isInvalid: d.validation.isInvalid==null || d.validation.isInvalid ? "invalid":"",
                                    className: d.validation.isInvalid ? "form-control is-invalid":"form-control",
                                    readOnly:getVarValue(d.readOnly) ? 'readOnly' : '',
                                    disabled:getVarValue(d.disabled) ? 'disabled' : '',

                                    autoComplete:f.autoComplete,
                                    list:f.list,
                                    maxLength:f.maxLength,
                                    minLength:f.minLength,
                                    pattern:f.pattern,
                                    size:f.size,
                                    spellcheck:f.spellcheck,
                                    ref:fieldD.InputRef
                                }}
                                />
                                   { /*
                                    title={fieldD.display.title}
                                    isInvalid={d.validation.isInvalid ? "invalid":""}
                                    readOnly={getVarValue(d.readOnly) ? 'readOnly' : ''}
                                    disabled={d.disabled ? 'disabled' : ''}

                                    autoComplete={f.autoComplete}
                                    list={f.list}
                                    maxLength={f.maxLength}
                                    minLength={f.minLength}
                                    pattern={f.pattern}
                                    size={f.size}
                                    spellcheck={f.spellcheck}
                                    ref={fieldD.InputRef}
                                */}
                                <Form.Text className="text-muted">
                                    {getVarValue(fieldD.display.description)}
                                </Form.Text>
                                <Form.Control.Feedback className={d.validation.isInvalid ? "is-invalid":""} type="invalid">
                                    {f.functions.displayErrorsFunc(f.fieldName)}
                                </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                );
            default:
                return (<h3>{fieldD.type}</h3>);
        }
    }
    else {
        return null;
    }
    
   /* return (
        getVarValue(d.displayField) == true ? 
            <Form.Group as={Row} className="mb-3" controlId={d.name}>
                {displayLabelFunc(fieldName,hideLabel)}
                <Col lg={5}>
                    <Form.Control
                        type={d.type}
                        name={d.name}
                        placeholder={d.display.placeholder}
                        title={d.display.title}
                        onChange={d.onChange}
                        isInvalid={d.validation.isInvalid ? "invalid":""}
                        readOnly={getVarValue(d.readOnly) ? 'readOnly' : ''}
                        disabled={d.disabled ? 'disabled' : ''}

                        maxLength="80"
                    />
                    <Form.Text className="text-muted">
                        {getVarValue(d.display.description)}
                    </Form.Text>
                    <Form.Control.Feedback type="invalid">
                        {displayErrorsFunc(fieldName)}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            : null

    );*/
}
